import type { QueryClient } from "@tanstack/react-query";
import { createRouter, type RouterHistory } from "@tanstack/react-router";
import { routeTree } from "~/app/router/routeTree.gen";
import { setActiveStorefrontRouter } from "~/app/router/activeStorefrontRouter";
import { PagePendingFallback } from "~/app/router/lazyPage";

export function createStorefrontRouter(queryClient: QueryClient, history?: RouterHistory) {
  const router = createRouter({
    routeTree,
    basepath: window.__SCHA_BOOT__?.contextPath || "/",
    context: {
      queryClient,
    },
    history,
    // Never swap the viewport during loader await (pre-migration behavior: the
    // committed page stays on screen until the new route's loader resolves).
    // The pending component only acts as the Suspense fallback while an
    // auto-split route component chunk loads; the shell renders from __root,
    // so the fallback shows inside the shell context via the router boundary.
    defaultPendingComponent: PagePendingFallback,
    defaultPendingMs: Infinity,
  });

  // Register the live router for non-hook navigation (`spaNavigateOrRedirect`,
  // the headless takeover host's click interceptor): the typed registry that
  // replaced the former `window.SCHA.navigate` bridge. Both hosts mount through
  // StorefrontShellRouterHost, so registration at creation covers each.
  setActiveStorefrontRouter(router);

  return router;
}
